import { 
  Building2, 
  Shield, 
  Lock, 
  Award,
  Briefcase,
  Factory,
  Truck,
  Banknote,
  ShoppingCart,
  Hospital,
  School,
  Globe
} from "lucide-react";

const industries = [
  {
    name: "Healthcare",
    icon: <Hospital className="w-12 h-12" />,
  },
  {
    name: "Finance",
    icon: <Banknote className="w-12 h-12" />,
  },
  {
    name: "Retail",
    icon: <ShoppingCart className="w-12 h-12" />,
  },
  {
    name: "Manufacturing",
    icon: <Factory className="w-12 h-12" />,
  },
  {
    name: "Logistics",
    icon: <Truck className="w-12 h-12" />,
  },
  {
    name: "Education",
    icon: <School className="w-12 h-12" />,
  },
  {
    name: "Real Estate",
    icon: <Building2 className="w-12 h-12" />,
  },
  {
    name: "Insurance",
    icon: <Shield className="w-12 h-12" />,
  },
  {
    name: "Legal",
    icon: <Briefcase className="w-12 h-12" />,
  },
  {
    name: "Government",
    icon: <Award className="w-12 h-12" />,
  },
  {
    name: "Telecom",
    icon: <Globe className="w-12 h-12" />,
  },
  {
    name: "Security",
    icon: <Lock className="w-12 h-12" />,
  }
];

const IndustriesSection = () => {
  const scrollToFooter = () => {
    const footer = document.getElementById('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">
            Industries We <span className="gradient-text">Serve</span>
          </h2>
          <p className="section-subtitle">
            Tailored AI and software solutions for every sector, optimized for your specific industry challenges.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          {industries.map((industry, index) => (
            <div 
              key={index} 
              className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-all duration-300 hover:bg-emerald-50 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="flex flex-col items-center text-center">
                <div className="text-gray-400 mb-4 group-hover:text-emerald-500 transition-colors duration-300">
                  {industry.icon}
                </div>
                <h3 className="font-montserrat font-medium text-gray-800 group-hover:text-emerald-600 transition-colors duration-300">
                  {industry.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <p className="text-gray-600 mb-2">
            Don't see your industry? Our solutions are adaptable to any business sector.
          </p>
          <button 
            onClick={scrollToFooter}
            className="font-semibold text-emerald-600 hover:text-emerald-700 transition-colors"
          >
            Contact us for customized solutions →
          </button>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
